import {
  Box,
  Container,
  makeStyles,
  Typography,
  Paper,
  TextField,
  Button,
  Link,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import OtpScreen from './OtpScreen/OtpScreen';
import { isValidEmil } from '../utils/helpers';
import ResetPassword from './ResetPassword/ResetPassword';
import { sendOtpMail } from './ForgetPwdStore/forgetPwdSlice';
import useToast from '../../hooks/useToast';

const useStyles = makeStyles({
  boxContainerStyle: {
    height: '100vh',
    width: '100%',
  },
  containerStyle: {
    height: '100%',
  },
  loginFormContainerStyle: {
    height: '100%',
    width: '100%',
  },
  paperStyle: {
    maxWidth: 578,
    overflow: 'hidden',
    display: 'flex',
    flexGrow: 1,
  },
  loginFormStyle: {
    background: 'white',
    paddingTop: 48,
    paddingBottom: 58,
    paddingInline: 40,
  },
  formStyle: {
    marginTop: 40,
  },
  underlineText: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  mailIcon: {
    transform: 'scale(3.5)',
  },
});

const validate = (values) => {
  const errors = {};
  const { email } = values;
  if (!email) {
    errors.email = '**This field is required';
  } else if (!isValidEmil(email)) {
    errors.email = 'Please Enter a valid Email';
  }
  return errors;
};

function ForgetPwdScreen() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [showUserEmail, setShowUserEmail] = useState(true);
  const [showOtp, setShowOtp] = useState(false);
  const [showSetPwdScreen, setShowSetPwdScreen] = useState(false);
  const [disable, setDisable] = useState(false);
  const [otpValue, setOtpValue] = useState('');
  const { SuccessToast, ErrorToast } = useToast();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    onSubmit: async (values) => {
      const { email } = values;
      dispatch(sendOtpMail({ email: email }))
        .unwrap()
        .then((res) => {
          SuccessToast('OTP Send Successfully!');
          setShowUserEmail(false);
          setShowOtp(true);
          setDisable(true);
        })
        .catch((err) => {
          ErrorToast('This email is not registered yet!');
        });
    },
    validate,
  });

  const { email } = formik.values;
  return (
    <Box className={classes.boxContainerStyle}>
      <Container className={classes.containerStyle}>
        <Box
          display="flex"
          alignItems={'center'}
          justifyContent={'center'}
          className={classes.loginFormContainerStyle}>
          <Paper elevation={5} className={classes.paperStyle}>
            <Box
              className={classes.loginFormStyle}
              display={'flex'}
              flexDirection={'column'}
              flex={1}>
              <Box mt={3}>
                <Typography variant="h4">
                  {showSetPwdScreen ? (
                    <Typography
                      fontWeight={'fontWeightMedium'}
                      fontSize={22}
                      color="primary"
                      variant="h4">
                      Reset your password
                    </Typography>
                  ) : showUserEmail ? (
                    <>
                      <Typography
                        fontWeight={'fontWeightMedium'}
                        fontSize={22}
                        color="primary"
                        variant="h4">
                        Forgotten password?
                      </Typography>
                      <Box mt={2} />
                      <Typography>
                        <b>Reset now.</b> Enter the email address associated
                        with your account and we’ll send you a link to reset
                        your password.
                      </Typography>
                    </>
                  ) : showOtp ? (
                    <>
                      <Typography
                        fontWeight={'fontWeightMedium'}
                        fontSize={22}
                        color="primary"
                        variant="h4">
                        Thanks, check your email for instructions to reset your
                        password
                      </Typography>
                      <Box mt={2} />
                      <Typography>
                        If you haven’t received an email in 5 minutes, check
                        your spam or{' '}
                        <span
                          onClick={formik.handleSubmit}
                          style={{ color: '#fe4500' }}>
                          resend
                        </span>
                        .
                      </Typography>
                    </>
                  ) : null}
                </Typography>
              </Box>
              <form
                className={classes.formStyle}
                noValidate
                autoComplete="off"
                onSubmit={(e) => {
                  e.preventDefault();
                }}>
                {showSetPwdScreen ? (
                  <ResetPassword email={email} otpValue={otpValue} />
                ) : showOtp ? (
                  <OtpScreen
                    email={email}
                    setShowSetPwdScreen={setShowSetPwdScreen}
                    setOtpValue={setOtpValue}
                  />
                ) : (
                  <Box mt={-2}>
                    <TextField
                      fullWidth
                      disabled={disable ? true : false}
                      type="email"
                      name="email"
                      variant="outlined"
                      required
                      placeholder="yourname@work.com"
                      label="Registered email address"
                      value={email}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      error={formik.touched.email && formik.errors.email !== ''}
                      helperText={
                        formik.touched.email ? formik.errors.email : ''
                      }
                    />
                    {showOtp ? null : (
                      <Box mt={3}>
                        <Button
                          variant="contained"
                          color="primary"
                          fullWidth
                          onClick={formik.handleSubmit}>
                          Continue
                        </Button>
                        <Box mt={2} />
                        <Link href="/signin">
                          <Button variant="outlined" color="primary" fullWidth>
                            Return to Sign in
                          </Button>
                        </Link>
                      </Box>
                    )}
                  </Box>
                )}
              </form>
            </Box>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}

export default ForgetPwdScreen;
